import * as React from "react";
import { useLocalization } from "@shared-ui/localization-context";

import { UitkFigure, UitkImage } from "uitk-react-images";
import { UitkScrim } from "uitk-react-scrim";
import { UitkText } from "uitk-react-text";
import { UitkLayoutFlex } from "uitk-react-layout-flex";
import { UitkCard, UitkCardMedia, UitkCardContent, UitkCardTextSegment, UitkCardLink } from "uitk-react-cards";

import { getAuthorFromCityStayedAtHotelText, getPostedAgoText, ratingDescription } from "../../hotelRecentReviewsUtils";
import { TrackedLink } from "components/utility/analytics/TrackedLink";

import {
  HotelRecentReviewsFlexModuleResult,
  HotelReview,
} from "typings/microserviceModels/hotel-recent-reviews-flex-module";

const HeaderImageCard = (props: { model: HotelRecentReviewsFlexModuleResult; hotel: HotelReview }) => {
  const { model, hotel } = props;
  const { showTitleOfReviewForHeaderImageView } = model;
  const {
    hotelName,
    hotelImageUrl,
    hotelInfositeUrl,
    date: reviewPostedDate,
    rating,
    reviewTitle,
    reviewText,
    authorName,
    authorLocation,
  } = hotel;

  const { formatText } = useLocalization();

  return (
    <UitkCard>
      <UitkCardMedia>
        <UitkFigure ratio={UitkFigure.AspectRatio.R16_9}>
          <UitkImage src={hotelImageUrl} alt={hotelName} placeholderImage={true} />
          <UitkScrim>
            <UitkText size={500} weight="bold">
              {hotelName}
            </UitkText>
          </UitkScrim>
        </UitkFigure>
      </UitkCardMedia>

      <UitkCardContent>
        <UitkCardTextSegment>
          <UitkLayoutFlex direction="column">
            <UitkText className="uitk-type-heading-400 all-b-margin-two">
              {formatText("hotelRecentReviews.ratingSlashNoSpace", rating)} {ratingDescription(rating)}
            </UitkText>
            {showTitleOfReviewForHeaderImageView && (
              <UitkText className="uitk-type-heading-300 all-b-margin-two">{reviewTitle}</UitkText>
            )}
            <UitkText size={300} className="truncate-lines-2 all-b-margin-two">
              "{reviewText}"
            </UitkText>
            <UitkText size={200} className="truncate-lines-2 all-b-margin-two">
              {getAuthorFromCityStayedAtHotelText(authorName, authorLocation, hotelName)}
            </UitkText>
            <UitkText size={200}>{getPostedAgoText(reviewPostedDate)}</UitkText>
          </UitkLayoutFlex>
        </UitkCardTextSegment>
      </UitkCardContent>

      <UitkCardLink>
        <TrackedLink
          moduleName="hotelRecentReviews"
          rfrr="hotelInfositeLink"
          href={hotelInfositeUrl}
          data-testid={`hotel-recent-reviews-header-image-card-${hotelName}`}
        >
          {hotelName}
        </TrackedLink>
      </UitkCardLink>
    </UitkCard>
  );
};

export default HeaderImageCard;
